import React from "react";
import { useHookstate } from "@hookstate/core";
import { useLocation, useNavigate } from "react-router-dom";
// import ClientService from "../Services/ClientService";
import ClientService, { Product_Module } from "../Services/ClientService";
import { FullPageSpinner } from "../../Common/FullPageSpinner";
import SettingService, {
  IAddressDetails,
  IBankDetails,
  ICompanyInformation,
  ICompanySettings,
  IContactInformation,
  SettingsSections,
  VatSubmitType,
} from "../Services/SettingService";
import { InvoiceSkeleton, LayoutSkeleton } from "../../Common/Skeleton";
import { CompanyGSTTypes } from "../../Types/CommonConstants";
import { useDispatch } from "react-redux";
import { Utils } from "../../Utilities/Utils";
import { AuthService } from "../../Services/AuthService";
import { IApiResponse } from "../../Utilities/ApiUtility.axios";

export interface IClient {
  addresses?: IAddressDetails[];
  aliasName: string;
  appStartDate: any;
  autoNumber: number;
  businessStart: any;
  bankDetails?: IBankDetails;
  businessName: string;
  //clientType: string | null;
  gstType: CompanyGSTTypes;
  createdBy: any;
  clientId?: any;
  contactInformation?: IContactInformation[];
  defaultContact: any;
  email: string;
  id: string;
  isShippingSame: boolean;
  note: string;
  logo: any;
  msmeNo: string;
  pan: string;
  gstin: string;
  signature: any;
  panNo: string;
  phone: string;
  practiceId: number;
  recordStatus: number;
  state: number;
  registeredAddress: any;
  registrationNo?: string;
  shippingAddress: any;
  status: number;
  type: number;
  updatedBy: any;
  yearEnd: any;
  productModule?: Product_Module;
  financialYearBegin: string;
  //  gstDetails: IGstDetails;

  isGSTEnabled: boolean;
  registrationDate?: string;
  submitType?: VatSubmitType;
  // gst: IGstShort[] | undefined;
  gstRegDateString?: string;
  tdsDeductible?: boolean;
  tcsApplicability?: boolean;
  duration?: number;
  creditLimit?: number;
}

interface IGstSlabs {
  rate: number;
  name: string;
  id: number;
}

export enum IUpdateCompanySettings {
  onlyUpdate,
  addNew,
  delete,
}

interface IGstSlabs extends Array<IGstSlabs> {}

interface IClientContextProps {
  currentClient?: IClient;
  //clientAccountGroups?: IAccountGroups;
  //clientAccountTypes?: IAccountTypes;
  gstSlabs?: IGstSlabs;
  companySettings?: ICompanyInformation;
  updateCompanySettings: (
    section: SettingsSections,
    setting: Partial<ICompanyInformation>,
    val: any,
    addNewSettingCustomization?: IUpdateCompanySettings,
    voucherId?: number,
    voucherTitle?: string
  ) => any;
  updateClientDetails: (data: IClient, clientId: string | undefined) => any;
  loading?: boolean;
  activeKey?: string;
  setActiveKey?: any;
  totalDue?: number;
  setTotalDue?: any;
  setSalesInvoiceList?: any;
  salesInvoiceList?: any;
  setStatus?: any;
  status?: any;
  expensesList?: any;
  setExpensesList?: any;
  incomeList?: any;
  setIncomeList?: any;
  estimatehide?: any;
  SetEstimateHide?: any;
  DisplayResult?: boolean;
  setDisplayResult?: any;
  makeNewInvoice?: boolean;
  setMakeNewInvoice?: any;
}

interface IClientDataProviderProps {
  clientId: string;
  children?: any;
}

const ClientContext = React.createContext<Partial<IClientContextProps>>({});

const ClientDataProvider = ({
  clientId,
  children,
}: IClientDataProviderProps) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useHookstate<Partial<IClientContextProps>>({});
  const [loading, setLoading] = React.useState<boolean>(false);
  const [skeletonLoading, setSkeletonLoading] = React.useState<boolean>(false);
  const [activeKey, setActiveKey] = React.useState<string>("1");
  const [totalDue, setTotalDue] = React.useState<number>(0);
  const [status, setStatus] = React.useState<any>();
  const [DisplayResult, setDisplayResult] = React.useState<boolean>(false);
  const [makeNewInvoice, setMakeNewInvoice] = React.useState<boolean>(true);
  // const [context, setContext] = React.useState<{
  //   currentClient: any;
  //   gstSlabs: any;
  //   companySettings: any;
  // }>({
  //   currentClient: Utils.getLocal("currentClient"),
  //   gstSlabs: Utils.getLocal("gstSlabs"),
  //   companySettings: Utils.getLocal("companySettings"),
  // });

  const currentClient = state.currentClient.get({ noproxy: true });
  //const clientAccountGroups = state.clientAccountGroups.get({ noproxy: true });
  //const clientAccountTypes = state.clientAccountTypes.get({ noproxy: true });
  const gstSlabs = state.gstSlabs.get({ noproxy: true });
  const companySettings = state.companySettings.get({ noproxy: true });
  const mergeSettings = (
    result: boolean,
    toBeMergedSettings: Partial<ICompanyInformation>
  ) => {
    if (result) {
      state.companySettings.merge({ ...toBeMergedSettings });
    }
  };

  const updateCompanySettings = async (
    section: SettingsSections,
    setting: Partial<ICompanyInformation>,
    val: ICompanySettings,
    addNewSettingCustomization?: IUpdateCompanySettings,
    voucherId?: number,
    voucherTitle?: string
  ) => {
    // console.log("setting", section, setting, val, voucherId);
    // state.companySettings.merge({ ...setting });
    const result =
      addNewSettingCustomization === IUpdateCompanySettings.addNew
        ? await SettingService.addSettingCustomization(clientId!, val).then(
            (res: IApiResponse<boolean>) => {
              mergeSettings(res.status, setting);
              return res;
            }
          )
        : addNewSettingCustomization === IUpdateCompanySettings.delete
        ? await SettingService.deleteSettingCustomization(
            clientId!,
            voucherId!
          ).then((res: IApiResponse<boolean>) => {
            mergeSettings(res.status, setting);
            return res;
          })
        : await SettingService.updateCompanySettings(
            clientId!,
            section,
            val,
            voucherId || 0
          ).then((res: IApiResponse<boolean>) => {
            mergeSettings(res.status, setting);
            return res;
          });

    // debugger;
    // if (result.status) {
    //   state.companySettings.merge({ ...setting });
    //   // Utils.setLocal("companySettings", { ...setting });
    //   // setContext({ ...context, companySettings: setting });
    // }
    return result;
  };

  const updateClientDetails = async (
    data: IClient,
    clientId: string | undefined
  ) => {
    const result = await ClientService.post(data, clientId!);
    if (result.status) {
      state.currentClient.merge({ ...data });
    }
    return result;
  };

  React.useEffect(() => {
    let isMounted = true;

    const setCompanyDetails = async (clientId: string) => {
      const splittedPath = location.pathname.split("/");
      const Dpath = splittedPath[splittedPath?.length - 1];
      Dpath === "dashboard" ? setSkeletonLoading(true) : setLoading(true);
      try {
        const [client, settings] = await Promise.all([
          ClientService.getClient(clientId),
          SettingService.getCompanySettings(clientId, SettingsSections.All),
        ]);

        if (!isMounted) return;

        state.merge({
          currentClient: client?.result,
          gstSlabs: settings?.result?.gsts,
          companySettings: settings?.result,
        });
      } catch (err) {
        console.error("Error while fetching context details:", err);
      } finally {
        if (isMounted) {
          setLoading(false);
          setSkeletonLoading(false);
        }
      }
    };

    if (Utils.isValidObjectId(clientId)) {
      setCompanyDetails(clientId);
    } else {
      if (isMounted) {
        AuthService.logout().then(() => {
          console.error("Invalid client ID - Logging out");
          sessionStorage.clear();
          localStorage.clear();
          navigate("/login");
        });
      }
    }

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId]);

  let splittedpath = location.pathname.split("/");
  // if (loading) return <FullPageSpinner />;

  // let Dpath = splittedpath[splittedpath.length - 1];
  let InvPath = splittedpath[splittedpath.length - 1];
  if (loading) {
    return <FullPageSpinner />;
  } else if (skeletonLoading) {
    return <LayoutSkeleton />;
  } else if (loading && InvPath === "addInvoice") {
    return <InvoiceSkeleton loading={loading} setLoading={setLoading} />;
  }

  return (
    //clientAccountGroups: clientAccountGroups as IAccountGroups,
    //clientAccountTypes: clientAccountTypes as IAccountTypes,
    <div>
      <ClientContext.Provider
        value={{
          currentClient: currentClient as IClient,
          gstSlabs: gstSlabs as IGstSlabs,
          companySettings: companySettings as any,
          updateCompanySettings,
          loading,
          activeKey,
          setActiveKey,
          totalDue,
          setTotalDue,
          setStatus,
          status,
          DisplayResult,
          setDisplayResult,
          makeNewInvoice,
          setMakeNewInvoice,
          updateClientDetails,
        }}
        children={children}
      />
    </div>
  );
};

export default ClientDataProvider;

export function useClient() {
  const context = React.useContext(ClientContext);
  if (context === undefined) {
    throw new Error("ClientData context not defined");
  }
  return context;
}
